module.exports = __webpack_public_path__ + "img/31.5bcf1aba.jpg";